import { createStyles, makeStyles, Theme } from "@material-ui/core"

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: `100%`,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      minWidth: "140px",
    },
  })
)
